export default "<div #mapElement class=\"map\">\n  <div #popupElement class=\"popup\" style=\"display:none;\">\n  </div>\n</div>\n";